module.exports = __webpack_public_path__ + "static/favicon-d9176888b896bedc3e683052e33ec7a1.ico";